/* global $ */
$(document).ready(function () {
    let reviewsCount = 6;

    $('.show_more').on('click', function () {
        let currentCount = reviewsCount;
        let totalReviews = $(this).parent().parent().find('.review_item').length;

        $(this).parent().parent().find('.review_item:hidden').each(function () {
            if (reviewsCount < (currentCount + 6)) {
                $(this).show();
                reviewsCount++;
            }
        });

        if (totalReviews === reviewsCount) {
            $(this).remove();
        }
    });
});
